import React from 'react';

const TRAIL_TYPES = {
  'GR': {
    name: 'Gran Recorrido',
    nameEn: 'Long Distance Trail',
    nameDe: 'Fernwanderweg',
    colors: ['#FFFFFF', '#EF4444'],
    description: 'Más de 50 km. Señalizado con marcas rojas y blancas.',
    descEn: 'Over 50 km. Marked with red and white signs.',
    descDe: 'Über 50 km. Markiert mit rot-weißen Zeichen.',
  },
  'PR': {
    name: 'Pequeño Recorrido',
    nameEn: 'Short Distance Trail',
    nameDe: 'Kurzwanderweg',
    colors: ['#FFFFFF', '#EAB308'],
    description: 'Entre 10 y 50 km. Señalizado con marcas amarillas y blancas.',
    descEn: '10-50 km. Marked with yellow and white signs.',
    descDe: '10-50 km. Markiert mit gelb-weißen Zeichen.',
  },
  'SL': {
    name: 'Sendero Local',
    nameEn: 'Local Trail',
    nameDe: 'Örtlicher Wanderweg',
    colors: ['#FFFFFF', '#319795'],
    description: 'Menos de 10 km. Señalizado con marcas verdes y blancas.',
    descEn: 'Under 10 km. Marked with green and white signs.',
    descDe: 'Unter 10 km. Markiert mit grün-weißen Zeichen.',
  },
  'PNT': {
    name: 'Parque Nacional del Teide',
    nameEn: 'Teide National Park',
    nameDe: 'Teide Nationalpark',
    colors: ['#7C3AED', '#FFFFFF'],
    description: 'Sendero oficial del Parque Nacional. Regulado por el organismo autónomo.',
    descEn: 'Official National Park trail. Regulated by the park authority.',
    descDe: 'Offizieller Nationalpark-Wanderweg.',
  },
};

const TrailSignage = ({ matricula, language = 'es' }) => {
  if (!matricula) return null;

  // Extract trail type prefix
  const prefix = Object.keys(TRAIL_TYPES).find(p => matricula.toUpperCase().startsWith(p));
  if (!prefix) return null;

  const info = TRAIL_TYPES[prefix];
  const name = language === 'en' ? info.nameEn : language === 'de' ? info.nameDe : info.name;
  const desc = language === 'en' ? info.descEn : language === 'de' ? info.descDe : info.description;

  return (
    <div className="flex items-center gap-3" data-testid="trail-signage">
      {/* Visual signage mark */}
      <div className="flex flex-col w-8 h-10 rounded overflow-hidden shadow-sm flex-shrink-0 border border-gray-200">
        <div className="flex-1" style={{ backgroundColor: info.colors[0] }} />
        <div className="flex-1" style={{ backgroundColor: info.colors[1] }} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-bold text-sm text-gray-900">{matricula}</span>
          <span className="text-xs text-gray-400">•</span>
          <span className="text-xs font-medium text-gray-600">{name}</span>
        </div>
        <p className="text-xs text-gray-500 mt-0.5">{desc}</p>
      </div>
    </div>
  );
};

export default TrailSignage;
